enum ErrorType {
  NOT_FOUND = '404 - Page Not Found',
  GENERAL = 'General System Error',
}

export default ErrorType;
